/**
 * Глобальные состояния проекта
 */
const state = {
  // Состояние темной темы проекта
  themeDark: false,
  // свернуть/развернуть левую панель
  panelLeftDrawer: null,
  // список полных месяцев
  monthList: {
    monthNames: [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь"
    ]
  }
};

const mutations = {
  // смена темы
  SET_THEME_DARK(state, val) {
    state.themeDark = val;
  },
  // свернуть/развернуть левую панель
  SET_PANEL_LEFT_DRAWER(state, value) {
    state.panelLeftDrawer = value;
  }
};

const getters = {
  themeDark: state => {
    return state.themeDark;
  },
  panelLeftDrawer: state => {
    return state.panelLeftDrawer;
  },
  monthList: state => {
    return state.monthList;
  }
};

export default {
  state,
  mutations,
  getters
};
